// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_f6-a";
export var fulfillmentFormRail = "_f6-9";
export var headerTitleRow = "_f6-c";
export var orderDetailsWrapper = "_f6-7";
export var orderLinkTrigger = "_f6-2";
export var paymentInformationGrid = "_f6-h";
export var paymentSummaryColumn = "_f6-i";
export var shipmentContainer = "_f6-b";
export var shipmentDetailsMainPane = "_f6-8";
export var shipmentNavigationCard = "_f6-5";
export var shipmentNavigationRail = "_f6-3";
export var shipmentNavigationRailHeader = "_f6-4";
export var shipmentSummaryFact = "_f6-e";
export var shipmentSummaryGrid = "_f6-d";
export var shipmentSummaryMetadataRow = "_f6-f";
export var shipmentSummaryTags = "_f6-g";
export var shipmentWorkspace = "_f6-0";
export var shipmentWorkspaceContent = "_f6-6";
export var shipmentWorkspaceHeader = "_f6-1";